<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (loading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

<p-table #dt2 [loading]="loading" [lazy]="true" (onLazyLoad)="loadLazy($event)" [value]="blogs" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" (onRowSelect)="onRowSelect($event)"
  dataKey="blogId" selectionMode="single" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[50,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta"
  [(selection)]="blog" [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Blogs & Statements</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Blog/Statement +</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Blog/Statement +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'blogId', 'in')"></th> -->
        <th class="filter-input">
          <input
            pInputText
            type="text"
            placeholder=""
            [style]="{'width':'50px !important'}"
            (input)="dt2.filter($event.target.value, 'blogId', 'in')"
            ariaLabel="blogId">
        </th>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th> -->
        <th class="filter-input">
          <p-columnFilter
            type="text"
            matchMode="contains"
            [showMenu]="false"
            field="name"
            placeholder=""
            (input)="dt2.filter($event.target.value, 'name', 'in')"
          ariaLabel="name"></p-columnFilter>
        </th>
        <th class="filter-input">
          <p-dropdown #aa dropdownIcon="fa fa-caret-down" [options]="typesListForFilter" appendTo="body" (onChange)="dt2.filter($event.value, 'type', 'in')" styleClass="p-column-filter"
            placeholder="Filter" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th class="filter-input">
          <p-columnFilter field="status" matchMode="equals" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown #aa dropdownIcon="fa fa-caret-down" [options]="statuses" [(ngModel)]="status1"
                (onChange)="dt2.filter($event.value, 'status', 'in')" placeholder="Select" appendTo="body"
                optionLabel="name" optionValue="value">
                <ng-template let-option pTemplate="item">
                  <span>{{option.name}}</span>
                </ng-template>
              </p-dropdown>
            </ng-template>
          </p-columnFilter>
        </th>
        <th class="filter-input">
          <!-- <p-columnFilter field="locationId" matchMode="equals" [showMenu]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback"> -->
            <p-dropdown #aa dropdownIcon="fa fa-caret-down" [options]="locations"
              (onChange)="dt2.filter($event.value, 'locationId', 'in')" placeholder="Select" appendTo="body"
              optionLabel="name" optionValue="locationId">
              <ng-template let-option pTemplate="item">
                <span>{{option.name}}</span>
              </ng-template>
            </p-dropdown>
          <!-- </ng-template>
        </p-columnFilter> -->
      </th>
      <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th> -->
      <th class="filter-input">
        <p-columnFilter
          type="text"
          matchMode="contains"
          [showMenu]="false"
          field="blogDevelopmentVOList.addressDevelopmentName"
          placeholder=""
          (input)="dt2.filter($event.target.value, 'blogDevelopmentVOList.addressDevelopmentName', 'in')"
        ariaLabel="blogDevelopmentVOList.addressDevelopmentName"></p-columnFilter>
      </th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-blog>
  <tr [pSelectableRow]="blog">
    <td>{{blog.blogId}} </td>
    <td>{{blog.name}}</td>
    <td>{{blog?.type ? typesList[blog.type] : 'Blog'}}</td>
    <td>{{getStatusName(blog)}}</td>
    <td>{{blog?.locationId ? getLocationName(blog) : '-'}}</td>
    <td class="text-wrap">{{getAdrDevelopmentName(blog)}}</td>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(blog)"></i>
      </a>
    </span>
  </td>
</tr>
</ng-template>
</p-table>